/**
 * Centralized content configuration for the application
 * Manages all static content, allowing for easy updates and localization
 */

export const businessInfo = {
  company: {
    name: "Château de Clémentine",
    founded: 1993,
    email: "lechateaudeclementine@gmail.com",
    responseTime: "24h"
  },
  location: {
    address: {
      street: "Avenue de la Rosée 12",
      postalCode: "1640",
      city: "Rhode-Saint-Genèse",
      country: "Belgique"
    }
  },
  serviceAreas: [
    "Bruxelles", "Waterloo", "Nivelles", "Braine-l'Alleud",
    "Uccle", "Ixelles", "Etterbeek", "Woluwe-Saint-Pierre",
    "Auderghem", "Watermael-Boitsfort", "La Hulpe", "Genval"
  ],
  stats: {
    experience: "30+",
    experienceLabel: "Années d'expérience",
    events: "1000+",
    eventsLabel: "Événements organisés",
    satisfaction: "95%",
    satisfactionLabel: "Clients satisfaits",
    priceFrom: "À partir de 30€",
    priceLabel: "Week-end complet"
  }
};

export const processSteps = [
  {
    step: "1",
    title: "Réservation",
    description: "Utilisez notre formulaire de contact pour vérifier la disponibilité et réserver votre château ou sumo."
  },
  {
    step: "2", 
    title: "Retrait",
    description: "Venez récupérer votre matériel à Rhode-Saint-Genèse. Tout rentre dans une voiture avec hayon (sièges rabattus)."
  },
  {
    step: "3",
    title: "Montage",
    description: "Montage simple en moins de 10 minutes grâce à nos instructions détaillées. Aucune compétence technique requise."
  },
  {
    step: "4",
    title: "Retour",
    description: "Ramenez le matériel propre et sec. Inspection rapide et remboursement de la caution si tout est OK."
  }
];

export const chateauxService = {
  title: "Châteaux Gonflables - Service Complet",
  icon: "🏰",
  included: [
    "Château gonflable de qualité professionnelle",
    "Soufflerie électrique puissante (220V)",
    "Bâche de protection pour le sol",
    "Piquets d'ancrage pour la sécurité",
    "Diable pour faciliter le transport",
    "Instructions de montage détaillées"
  ],
  themes: [
    "Château Princesse", "Château Dino", "Château Disco", "Château Pingouin",
    "Château Vache", "Château Grenouille", "Twister gonflable", "Et bien d'autres..."
  ],
  safety: [
    "Matériel conforme aux normes européennes",
    "Contrôle qualité avant chaque location",
    "Assurance responsabilité civile",
    "Instructions de sécurité fournies"
  ]
};

export const sumosService = {
  title: "Sumos - Animation Unique",
  icon: "🤼",
  included: [
    "2 costumes de sumo gonflables",
    "Casques de protection intégrés",
    "Tapis de combat sécurisé",
    "Bâche de protection au sol"
  ],
  requirements: [
    "Minimum 150cm de taille",
    "Poids maximum 120kg par personne",
    "Idéal pour adolescents et adultes",
    "Supervision d'un adulte requise",
    "Utilisation en extérieur recommandée"
  ],
  occasions: [
    "Anniversaires d'adolescents",
    "Mariages et fêtes familiales",
    "Événements d'entreprise",
    "Festivals et kermesses",
    "Team building"
  ]
};

export const whyUsReasons = [
  {
    title: "Plus de 30 ans d'expérience",
    description: "Depuis 1993, nous créons des moments magiques pour des milliers de familles belges.",
    color: "bg-primary"
  },
  {
    title: "Montage simple et rapide",
    description: "On vous explique tout ! Montage simple en moins de 10 minutes, vous pouvez tout faire vous-même.",
    color: "bg-accent"
  },
  {
    title: "Retrait à Rhode-Saint-Genèse",
    description: "Venez récupérer votre château à Rhode-Saint-Genèse. Transport facile dans une voiture avec hayon.",
    color: "bg-fun"
  },
  {
    title: "Satisfaction clients",
    description: "Plus de 95% de nos clients nous recommandent à leur entourage.",
    color: "bg-secondary-light"
  }
];

export const sectionContent = {
  contact: {
    badge: "Contact",
    title: "Location de Château Gonflable",
    description: "Réservez dès maintenant votre château gonflable pour un événement inoubliable ! Devis gratuit et conseil personnalisé pour votre fête."
  },
  whyUs: {
    badge: "Pourquoi Nous Choisir",
    title: "Ne Cherchez Plus",
    description: "Avec plus de 30 ans d'expérience, Château de Clémentine est votre partenaire de confiance pour des événements réussis et des sourires garantis !",
    pickupNote: "Les châteaux rentrent facilement dans une voiture avec hayon (sièges rabattus)"
  },
  services: {
    badge: "Services Détaillés",
    title: "Tout ce que vous devez savoir sur nos services",
    description: "Depuis 1993, Château de Clémentine propose la location de châteaux gonflables et sumos en Belgique. Découvrez tous les détails de nos services professionnels pour vos événements."
  },
  process: {
    badge: "Comment ça marche",
    title: "Location simple en 4 étapes"
  },
  location: {
    badge: "Nous Trouver",
    title: "Rhode-Saint-Genèse, votre point de retrait",
    description: "Situés au cœur du Brabant wallon, nous desservons facilement Bruxelles, Waterloo, Nivelles et toute la région. Accès facile depuis l'autoroute.",
    serviceZoneTitle: "Zone de service",
    serviceZoneDescription: "Nous desservons principalement la région de Bruxelles-Capitale et le Brabant wallon. Transport facile depuis Rhode-Saint-Genèse vers toutes les communes avoisinantes."
  }
};